var map = {
	"./AffiliatePlans/List.vue": [
		10136,
		[
			9292,
			2666,
			2348
		]
	],
	"./AffiliatePlans/NewOrEdit.vue": [
		74992,
		[
			4992
		]
	],
	"./Auth/Login.vue": [
		80880,
		[
			880
		]
	],
	"./Auth/Logout.vue": [
		8913,
		[
			8913
		]
	],
	"./Auth/NewPassword.vue": [
		95573,
		[
			5573
		]
	],
	"./Auth/Quiz.vue": [
		5135,
		[
			5135
		]
	],
	"./Auth/Register.vue": [
		8862,
		[
			8862
		]
	],
	"./Auth/ResetPassword.vue": [
		33688,
		[
			3688
		]
	],
	"./Auth/VerifyEmail.vue": [
		31401,
		[
			1401
		]
	],
	"./Auth/partial/CloudFrontVerification.vue": [
		61806,
		[
			1806
		]
	],
	"./Auth/partial/EmailHints.vue": [
		7569,
		[
			7569
		]
	],
	"./Dashboard/View.vue": [
		79450,
		[
			9292,
			3898,
			5502,
			5301,
			1949,
			8284,
			2052,
			8972,
			3943,
			9581
		]
	],
	"./Gateways/List.vue": [
		29145,
		[
			9292,
			1809
		]
	],
	"./Gateways/NewOrEdit.vue": [
		98221,
		[
			8221
		]
	],
	"./Gateways/Process.vue": [
		93400,
		[]
	],
	"./Gateways/partial/CPay.vue": [
		6161,
		[
			6161
		]
	],
	"./Gateways/partial/Gateway.vue": [
		18356,
		[]
	],
	"./Gateways/partial/Gateways.vue": [
		85934,
		[]
	],
	"./Gateways/partial/Step4.vue": [
		68941,
		[]
	],
	"./Invoices/CreateInvoiceDialog.vue": [
		98929,
		[
			8929,
			1698
		]
	],
	"./Invoices/List.vue": [
		94184,
		[
			9292,
			8469,
			8929,
			2595
		]
	],
	"./Invoices/PayInvoiceDialog.vue": [
		78469,
		[
			8469
		]
	],
	"./Invoices/RefundInvoiceDialog.vue": [
		79287,
		[
			9287
		]
	],
	"./Invoices/View.vue": [
		9213,
		[
			8469,
			9213
		]
	],
	"./Members/Members.vue": [
		94838,
		[
			9292,
			3861,
			3957,
			7915,
			1314
		]
	],
	"./Members/partial/AddAdministrator.vue": [
		83957,
		[
			3861,
			3957,
			2757
		]
	],
	"./Members/partial/CardRole.vue": [
		18383,
		[
			8383
		]
	],
	"./Members/partial/CreateOrEditRole.vue": [
		23861,
		[
			3861,
			168
		]
	],
	"./Members/partial/SettingsRoleDialog.vue": [
		94947,
		[
			3861,
			5038
		]
	],
	"./Members/partial/TeamMembers.vue": [
		7915,
		[
			9292,
			7915,
			5475
		]
	],
	"./Modules/BulkPayouts/List.vue": [
		25120,
		[
			9292,
			2276
		]
	],
	"./Modules/BulkPayouts/partial/UploadFileDialog.vue": [
		10653,
		[
			653
		]
	],
	"./Modules/Cms/List.vue": [
		67266,
		[
			9292,
			6380,
			8356,
			1372
		]
	],
	"./Modules/Cms/NewOrEditForm.vue": [
		68356,
		[
			6380,
			8356,
			3987
		]
	],
	"./Modules/Cms/patrial/SelectIconsDialog.vue": [
		6380,
		[
			6380
		]
	],
	"./Modules/Configuration/List.vue": [
		85323,
		[
			9292,
			7855
		]
	],
	"./Modules/Configuration/NewOrEdit.vue": [
		57312,
		[
			7312
		]
	],
	"./Modules/Crowdfunding/List.vue": [
		24837,
		[
			9292,
			3898,
			5502,
			5301,
			4002,
			3212,
			7298,
			4837
		]
	],
	"./Modules/Crowdfunding/NewOrEditForm.vue": [
		99493,
		[
			9292,
			3898,
			5502,
			5301,
			4002,
			3212,
			7298
		]
	],
	"./Modules/Crowdfunding/patrial/EditCurrentPrice.vue": [
		41225,
		[
			1225
		]
	],
	"./Modules/Crowdfunding/patrial/EditMembersDialog.vue": [
		93212,
		[
			9292,
			3898,
			3212,
			2874
		]
	],
	"./Modules/Crowdfunding/patrial/Files.vue": [
		93974,
		[
			9292,
			7630
		]
	],
	"./Modules/Crowdfunding/patrial/PayoutDialog.vue": [
		49709,
		[
			9709
		]
	],
	"./Modules/Crowdfunding/patrial/Products.vue": [
		54715,
		[
			4715
		]
	],
	"./Modules/Deals/List.vue": [
		62584,
		[
			9292,
			5831,
			9826
		]
	],
	"./Modules/Deals/partial/NewOrEdit.vue": [
		85831,
		[
			5831,
			2887
		]
	],
	"./Modules/Deals/partial/dealStatus.vue": [
		37004,
		[
			7004
		]
	],
	"./Modules/Deals/partial/viewMode.vue": [
		52645,
		[
			2645
		]
	],
	"./Modules/DefiModules/List.vue": [
		88981,
		[
			9292,
			3898,
			4070,
			100
		]
	],
	"./Modules/DefiModules/NewOrEditForm.vue": [
		24070,
		[
			3898,
			4070,
			6148
		]
	],
	"./Modules/DefiModules/RecalculateDialog.vue": [
		60964,
		[
			964
		]
	],
	"./Modules/DigitalContracts/FieldWidget.vue": [
		94885,
		[
			4885
		]
	],
	"./Modules/DigitalContracts/List.vue": [
		65160,
		[
			9292,
			3898,
			6974,
			5790,
			4408
		]
	],
	"./Modules/DigitalContracts/NewOrEdit.vue": [
		85790,
		[
			3898,
			6974,
			5790,
			3399
		]
	],
	"./Modules/DigitalContracts/PDFMarkingDialog.vue": [
		16974,
		[
			3898,
			6974,
			9362
		]
	],
	"./Modules/DigitalContracts/index.vue": [
		6320,
		[
			9292,
			3898,
			6974,
			5790,
			6480
		]
	],
	"./Modules/Game/Airdrops/List.vue": [
		8369,
		[
			9292,
			233
		]
	],
	"./Modules/Game/Airdrops/NewOrEditForm.vue": [
		54648,
		[
			3898,
			5502,
			8516,
			6779
		]
	],
	"./Modules/Game/Boosters/List.vue": [
		7719,
		[
			9292,
			3898,
			150,
			7554
		]
	],
	"./Modules/Game/Boosters/NewOrEditForm.vue": [
		50150,
		[
			3898,
			150,
			7828
		]
	],
	"./Modules/Game/Charities/List.vue": [
		41391,
		[
			9292,
			3898,
			1330,
			447
		]
	],
	"./Modules/Game/Charities/NewOrEditForm.vue": [
		91330,
		[
			3898,
			1330,
			4777
		]
	],
	"./Modules/Game/Earns/List.vue": [
		60639,
		[
			9292,
			3898,
			5502,
			290,
			8770
		]
	],
	"./Modules/Game/Earns/NewOrEditForm.vue": [
		290,
		[
			3898,
			5502,
			290,
			68
		]
	],
	"./Modules/Game/PromoCodeSwap/List.vue": [
		68387,
		[
			9292,
			9848,
			7172
		]
	],
	"./Modules/Game/PromoCodeSwap/NewOrEditForm.vue": [
		29848,
		[
			9848,
			7906
		]
	],
	"./Modules/Investments/List.vue": [
		67034,
		[
			9292,
			2504,
			9138
		]
	],
	"./Modules/Investments/NewOrEdit.vue": [
		12504,
		[
			2504,
			61
		]
	],
	"./Modules/Ito/List.vue": [
		22802,
		[
			9292,
			5502,
			4993,
			3654,
			8349
		]
	],
	"./Modules/Ito/NewOrEditForm.vue": [
		43654,
		[
			5502,
			4993,
			3654,
			9108
		]
	],
	"./Modules/Ito/patrial/EditCurrentPrice.vue": [
		14745,
		[
			4745
		]
	],
	"./Modules/Ito/patrial/ProductsITO.vue": [
		98129,
		[
			8129
		]
	],
	"./Modules/Licenses/List.vue": [
		68476,
		[
			9292,
			118,
			27,
			4295,
			2619
		]
	],
	"./Modules/Licenses/partial/EditRequestStatus.vue": [
		90118,
		[
			118,
			5534
		]
	],
	"./Modules/Licenses/partial/LicenseView.vue": [
		70027,
		[
			9292,
			118,
			27,
			5238
		]
	],
	"./Modules/Licenses/partial/Purchase.vue": [
		48973,
		[
			8973
		]
	],
	"./Modules/Licenses/partial/RequestsView.vue": [
		44295,
		[
			9292,
			118,
			4295,
			9517
		]
	],
	"./Modules/Lms/List.vue": [
		13979,
		[
			9292,
			3898,
			5301,
			4002,
			9492,
			4091,
			1667,
			4917,
			9967,
			3979
		]
	],
	"./Modules/Lms/NewOrEditForm.vue": [
		25045,
		[
			9292,
			3898,
			5301,
			4002,
			9492,
			4091,
			1667,
			4917,
			9967,
			5045
		]
	],
	"./Modules/Lms/partial/CourseLabelForm.vue": [
		21667,
		[
			3898,
			1667,
			3879
		]
	],
	"./Modules/Lms/partial/FilesLabel/List.vue": [
		34917,
		[
			9292,
			4917,
			9290
		]
	],
	"./Modules/Lms/partial/FilesLabel/partial/NewOrEditFile.vue": [
		49560,
		[
			9560
		]
	],
	"./Modules/Lms/partial/LecturesLabel/List.vue": [
		98977,
		[
			9292,
			4002,
			9492,
			4091
		]
	],
	"./Modules/Lms/partial/LecturesLabel/partial/NewOrEditLecture.vue": [
		29492,
		[
			4002,
			9492,
			2335
		]
	],
	"./Modules/Lms/partial/LecturesLabel/partial/NewOrEditSection.vue": [
		76543,
		[
			6543
		]
	],
	"./Modules/Lotteries/List.vue": [
		60368,
		[
			9292,
			3898,
			5502,
			5301,
			8516,
			3350,
			6602,
			4765,
			7969
		]
	],
	"./Modules/Lotteries/NewOrEditForm.vue": [
		73335,
		[
			3898,
			5502,
			5301,
			8516,
			3350,
			6602,
			9945
		]
	],
	"./Modules/Lotteries/partial/ConfirmFinish.vue": [
		77390,
		[
			7390
		]
	],
	"./Modules/Lotteries/partial/GeneralForm.vue": [
		73350,
		[
			3898,
			5502,
			8516,
			3350,
			3751
		]
	],
	"./Modules/Lotteries/partial/LinkedProducts.vue": [
		5846,
		[
			5846
		]
	],
	"./Modules/Lotteries/partial/Rewards.vue": [
		54216,
		[
			4216
		]
	],
	"./Modules/Lotteries/partial/SendTicketsDialog.vue": [
		24765,
		[
			4765,
			2392
		]
	],
	"./Modules/Lotteries/partial/WinnersDetails.vue": [
		36575,
		[
			9292,
			2459
		]
	],
	"./Modules/Products/Dashboard/View.vue": [
		35260,
		[
			5260
		]
	],
	"./Modules/Products/Dashboard/partial/Overview.vue": [
		15686,
		[
			5686
		]
	],
	"./Modules/Products/Dashboard/partial/StatsTable.vue": [
		27114,
		[
			7114
		]
	],
	"./Modules/Products/List.vue": [
		24957,
		[
			9292,
			6596,
			4076,
			7107
		]
	],
	"./Modules/Products/NewOrEdit.vue": [
		34076,
		[
			9292,
			6596,
			4076,
			1959
		]
	],
	"./Modules/Products/partial/CheckoutLinkDialog.vue": [
		91259,
		[
			1259
		]
	],
	"./Modules/Products/partial/EditCategoriesDialog.vue": [
		6596,
		[
			9292,
			6596,
			5497
		]
	],
	"./Modules/Products/partial/UpgradableProducts.vue": [
		17602,
		[
			7602
		]
	],
	"./Modules/PromoCodes/List.vue": [
		30334,
		[
			9292,
			5039,
			4977
		]
	],
	"./Modules/PromoCodes/NewOrEdit.vue": [
		95039,
		[
			5039,
			4914
		]
	],
	"./Modules/RoadMap/List.vue": [
		87141,
		[
			9292,
			5502,
			1249,
			227,
			7141
		]
	],
	"./Modules/RoadMap/NewOrEdit.vue": [
		27005,
		[
			9292,
			5502,
			1249,
			227
		]
	],
	"./Modules/RoadMap/partial/EditStageDialog.vue": [
		51249,
		[
			9292,
			1249,
			7878
		]
	],
	"./Modules/SpotFutures/Connections/View.vue": [
		53106,
		[
			9292,
			5502,
			5301,
			5336,
			6000,
			603
		]
	],
	"./Modules/SpotFutures/Connections/partial/BalanceHistory.vue": [
		17539,
		[
			9292,
			5502,
			6949
		]
	],
	"./Modules/SpotFutures/Connections/partial/DisconnectDialog.vue": [
		82016,
		[
			2016
		]
	],
	"./Modules/SpotFutures/Connections/partial/TraderView.vue": [
		36000,
		[
			5336,
			6000,
			9403
		]
	],
	"./Modules/SpotFutures/Connections/partial/ViewKeySecretDialog.vue": [
		48529,
		[
			8529
		]
	],
	"./Modules/SpotFutures/Dashboard/View.vue": [
		63943,
		[
			5502,
			1949,
			2052,
			3943,
			3901
		]
	],
	"./Modules/SpotFutures/Dashboard/partial/AumPie.vue": [
		27697,
		[
			1949,
			7697
		]
	],
	"./Modules/SpotFutures/Dashboard/partial/Overview.vue": [
		61936,
		[
			1936
		]
	],
	"./Modules/SpotFutures/Dashboard/partial/StatsTable.vue": [
		98376,
		[
			8376
		]
	],
	"./Modules/SpotFutures/Dashboard/partial/StrategyStats.vue": [
		42052,
		[
			5502,
			2052,
			6962
		]
	],
	"./Modules/SpotFutures/LinkedAccounts/List.vue": [
		40267,
		[
			9292,
			9871
		]
	],
	"./Modules/SpotFutures/Strategies/List.vue": [
		83235,
		[
			9292,
			5502,
			7557
		]
	],
	"./Modules/SpotFutures/Strategies/NewOrEdit.vue": [
		68770,
		[
			5301,
			3004,
			4401,
			922,
			8472,
			487
		]
	],
	"./Modules/SpotFutures/Strategies/View.vue": [
		98926,
		[
			5502,
			5301,
			1949,
			5336,
			3799,
			1011
		]
	],
	"./Modules/SpotFutures/Strategies/partial/FeeStructure.vue": [
		27763,
		[
			7763
		]
	],
	"./Modules/SpotFutures/Strategies/partial/FormDataRoom.vue": [
		48472,
		[
			8472,
			6608
		]
	],
	"./Modules/SpotFutures/Strategies/partial/FormDetails.vue": [
		10922,
		[
			922
		]
	],
	"./Modules/SpotFutures/Strategies/partial/FormProfile.vue": [
		24401,
		[
			3004,
			4401,
			7322
		]
	],
	"./Modules/SpotFutures/Strategies/partial/MoveStrategyDialog.vue": [
		2447,
		[
			2447
		]
	],
	"./Modules/SpotFutures/Strategies/partial/PnLSmallChart.vue": [
		58673,
		[
			8673
		]
	],
	"./Modules/SpotFutures/Strategies/partial/TraderBalanceChart.vue": [
		51495,
		[
			5502,
			1949,
			3799,
			877
		]
	],
	"./Modules/SpotFutures/Strategies/partial/TraderPerformance.vue": [
		18439,
		[
			1949,
			8439
		]
	],
	"./Modules/SpotFutures/Strategies/partial/TraderResult.vue": [
		53008,
		[
			3008
		]
	],
	"./Modules/Staking/List.vue": [
		43415,
		[
			9292,
			4993,
			7811
		]
	],
	"./Modules/Staking/NewOrEdit.vue": [
		23283,
		[
			4993,
			3283
		]
	],
	"./Modules/Staking/UserDetails.vue": [
		45559,
		[
			5559
		]
	],
	"./Modules/TradingPortfolio/Dashboard/View.vue": [
		98972,
		[
			9292,
			3898,
			5301,
			1949,
			8284,
			8972,
			2485
		]
	],
	"./Modules/TradingPortfolio/Dashboard/partial/ClientsList.vue": [
		11432,
		[
			9292,
			3898,
			8284
		]
	],
	"./Modules/TradingPortfolio/Dashboard/partial/DepositsSummary.vue": [
		78185,
		[
			8185
		]
	],
	"./Modules/TradingPortfolio/Dashboard/partial/FundCard.vue": [
		89956,
		[
			9956
		]
	],
	"./Modules/TradingPortfolio/Dashboard/partial/KpiCards.vue": [
		38846,
		[
			8846
		]
	],
	"./Modules/TradingPortfolio/Dashboard/partial/NavHistoryChart.vue": [
		92450,
		[
			1949,
			2450
		]
	],
	"./Modules/TradingPortfolio/Dashboard/partial/SyncIndicator.vue": [
		51648,
		[
			1648
		]
	],
	"./MyInvoices/List.vue": [
		58158,
		[
			9292,
			4758
		]
	],
	"./MyInvoices/ThankYou.vue": [
		73916,
		[
			3916
		]
	],
	"./MyInvoices/View.vue": [
		76113,
		[
			6113
		]
	],
	"./Profile/Profile.vue": [
		2492,
		[
			2492
		]
	],
	"./Security/View.vue": [
		53177,
		[
			7950,
			5466,
			3736
		]
	],
	"./Security/partial/DeactivateTwoFaDialog.vue": [
		94085,
		[
			7950,
			7234
		]
	],
	"./Security/partial/EmailVerificationCode.vue": [
		51613,
		[
			1613
		]
	],
	"./Security/partial/LoginHistoryView.vue": [
		13485,
		[
			3485
		]
	],
	"./Security/partial/TwoFaDialog.vue": [
		85466,
		[
			5466,
			3621
		]
	],
	"./Security/partial/TwoFaVerification.vue": [
		17950,
		[
			7950,
			254
		]
	],
	"./Security/partial/TwoFaView.vue": [
		12725,
		[
			7950,
			5466,
			1900
		]
	],
	"./Tariffs/List.vue": [
		42773,
		[
			2024,
			7373
		]
	],
	"./Tariffs/partial/CardTariff.vue": [
		94386,
		[
			4386
		]
	],
	"./Tariffs/partial/DetailDialog.vue": [
		42024,
		[
			2024,
			5937
		]
	],
	"./Transactions/List.vue": [
		28615,
		[
			9292,
			8003
		]
	],
	"./Users/List.vue": [
		90360,
		[
			9292,
			5502,
			2399,
			3930,
			9951,
			4252
		]
	],
	"./Users/partial/BalanceEditDialog.vue": [
		29951,
		[
			9951,
			2005
		]
	],
	"./Users/partial/ChangeReferrerDialog.vue": [
		53930,
		[
			3930,
			9317
		]
	],
	"./Users/partial/DeleteDialog.vue": [
		29658,
		[
			9658
		]
	],
	"./Users/partial/Details.vue": [
		62399,
		[
			9292,
			2399,
			2499
		]
	],
	"./Users/partial/EditDialog.vue": [
		62440,
		[
			2440
		]
	],
	"./Users/partial/Purchase.vue": [
		95996,
		[
			5996
		]
	],
	"./Users/partial/Referrals.vue": [
		77900,
		[
			7900
		]
	],
	"./Users/partial/Sponsor.vue": [
		94935,
		[
			4935
		]
	],
	"./Users/partial/TrialPeriodDialog.vue": [
		58160,
		[
			5502,
			4416
		]
	],
	"./Users/partial/UserEditDialog.vue": [
		26509,
		[
			6509
		]
	],
	"./WhiteLabel/List.vue": [
		39700,
		[
			9292,
			4704
		]
	],
	"./WhiteLabel/NewOrEdit.vue": [
		59474,
		[
			5301,
			3004,
			4284,
			9251,
			1163,
			3910,
			2666,
			1731
		]
	],
	"./WhiteLabel/partial/WhiteLabelDesign.vue": [
		75383,
		[
			3004,
			4284,
			9388
		]
	],
	"./WhiteLabel/partial/WhiteLabelDesignDark.vue": [
		64060,
		[
			3004,
			4060
		]
	],
	"./WhiteLabel/partial/WhiteLabelDesignLight.vue": [
		56735,
		[
			3004,
			6735
		]
	],
	"./WhiteLabel/partial/WhiteLabelMarketing.vue": [
		8192,
		[
			8192
		]
	],
	"./WhiteLabel/partial/WhiteLabelMockup.vue": [
		32430,
		[
			2430
		]
	],
	"./WhiteLabel/partial/WhiteLabelModules.vue": [
		72151,
		[
			2151
		]
	],
	"./WhiteLabel/partial/WhiteLabelPaymentGateways.vue": [
		3821,
		[
			3821
		]
	],
	"./WhiteLabel/partial/WhiteLabelProfile.vue": [
		69251,
		[
			9251,
			6460
		]
	],
	"./WhiteLabel/partial/WhiteLabelSetting.vue": [
		23910,
		[
			3910
		]
	],
	"./WhiteLabel/partial/WhiteLabelSubscription.vue": [
		11163,
		[
			1163
		]
	],
	"./WhiteLabel/partial/WhiteLabelSupport.vue": [
		85198,
		[
			5198
		]
	],
	"./WhiteLabel/partial/WhiteLabelTheme.vue": [
		14284,
		[
			3004,
			4284,
			8949
		]
	],
	"./WhiteLabel/partial/svgMockDark.vue": [
		73935,
		[
			3935
		]
	],
	"./WhiteLabel/partial/svgMockDarkEng.vue": [
		65948,
		[
			5948
		]
	],
	"./WhiteLabel/partial/svgMockLight.vue": [
		10386,
		[
			386
		]
	],
	"./WhiteLabel/partial/svgMockLightEng.vue": [
		43051,
		[
			3051
		]
	],
	"./Withdrawals/AutomatedPayoutDialog.vue": [
		26021,
		[
			6021
		]
	],
	"./Withdrawals/AutomationDialog.vue": [
		82296,
		[
			2296
		]
	],
	"./Withdrawals/List.vue": [
		58314,
		[
			9292,
			7920,
			8282
		]
	],
	"./Withdrawals/ProcessDialog.vue": [
		27920,
		[
			7920,
			3289
		]
	],
	"./Withdrawals/partial/RequestCancel.vue": [
		77893,
		[
			7893
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 78970;
module.exports = webpackAsyncContext;